<template>
  <div class="cash-withdrawal">
    <div style="position: fixed; top: 50%; left: 50%; z-index: 999;">
      <atom-spinner
        v-if="loading"
        :animation-duration="speed"
        :size="config.size"
        :color="spinnersColor"
      />
    </div>

    <div class="mb-3" v-if="processingError">
      <va-notification color="danger" closeable>       
        An error occurred! Please Try again later.
      </va-notification>
    </div>

    <div class="mb-3" v-if="!canProcess">
      <va-notification color="danger" closeable>       
       Dear member, kindly note that you must be a registered mobile banking user to use this service. Please visit Chuna SACCO offices to register for mobile banking services. Thank you
      </va-notification>
    </div>

    <div class="row">
      <div class="flex xs12 md6 lg6" >
        <va-card>
          <template #title>
    {{ $t('activities.withdraw_form') }}
  </template>
          <form @submit.prevent="onsubmit">
            <va-input
              :label="$t('amount')"
              type="number"
              v-model="formdata.amount"
              :error="!!amountErrors.length"
              :error-messages="amountErrors"
            />
            <div class="row mt-5">            
              <va-button type="submit" :disabled="isLoading" >
                {{ $t('forms.controls.submit') }}
              </va-button>                        
            </div>
          </form>
        </va-card>
      </div>
    </div>
    <va-modal
      v-model="showConfirmModal"
      position="top"
      size = "medium"
      :title=" $t('confirm_trans')"
      cancelClass="none"      
      :okText=" $t('modal.confirm') "
      :hideDefaultActions = "hideactions"     
      :cancelText=" $t('modal.cancel')"      
      noOutsideDismiss
      noEscDismiss
      @ok = "FinalPost"
    >
      <table class="va-table va-table--striped va-table--hoverable" width="100%">
        <tbody>
          <tr>
            <td>Withdraw To</td>
            <td style="text-align: right;">{{ userData.mobile_number }}</td>
          </tr>
          <tr>
            <td>Withdraw From</td>
            <td style="text-align: right;">{{ accdetails.accname }}</td>
          </tr> 
          <tr>
            <td>Available Balance</td>
            <td style="text-align: right;">{{ accdetails.balance | Currency }}</td>
          </tr>
          <tr>
            <td>Amount</td>
            <td style="text-align: right;">{{ formdata.amount | Currency }}</td>
          </tr>
          <tr>
            <td>Charge</td>
            <td style="text-align: right;">{{ charge_amount | Currency }}</td>
          </tr> 
          <tr>
            <td>New Balance</td>
            <td style="text-align: right;">{{ accdetails.balance - (formdata.amount - - charge_amount) | Currency }}</td>
          </tr>                 
        </tbody>
      </table>

    </va-modal>
    
  </div>
</template>

<script>
import axios from 'axios'
import * as spinners from 'epic-spinners'
export default {
  components: {
    ...spinners      
  },
  name: 'cash-withdrawal',
  data () {
    return {
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      accdetails: JSON.parse(localStorage.getItem('UserMianFosa')),
      token: JSON.parse(localStorage.getItem('Token')),           
      loading: false,
      hideactions:false,
      canProcess : false,
      isLoading: false,
      response:{        
      },
      charge_amount:'',   
      processingError: false,
      showConfirmModal : false,
      config: {
        size: 80,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      sliderDuration: {
        min: 1000,
        max: 2000,
      },
      formdata:{
        amount:''        
      },
      amountErrors : [],
    }
  },
  computed: {
    speed () {
      return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
    },

    formReady () {
        return !this.amountErrors.length
    }
  }, 
  methods : {    
    onsubmit(e){
      e.preventDefault();
     
      this.processingError = false;      
      this.amountErrors = this.formdata.amount ? [] : ['Amount is required']
      
      if (this.formReady) { 
        this.isLoading=true       
        this.loading = true;     

        var self = this

        let config = {
          headers: {
            Authorization: this.userData.user_id+' '+this.token
          }
        }

        axios.post(`${this.$apiUrl}GetWithdrwalCharge`, this.formdata, config)
        .then(function (res) {
          self.loading = false        
          const resp = res.data
          if (resp.success == 0) {
            self.isLoading=false
            self.amountErrors = [resp.message] 
            self.showToast(resp.message, {  
                          
              position: 'bottom-right',
              icon: "fa-times",
              duration: 10000,
              
            })
          }else{
            self.charge_amount = resp.amount
            self.response = resp
            self.showConfirmModal = true;
          }
          
        })
        .catch(function (error) {
            console.log(error)
        })       
      }
    },

    FinalPost(){
      var self = this
      this.hideactions = true

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${this.$apiUrl}withdrawMoneyFinal`, this.formdata, config)
      .then(function (res) {
        self.loading = false        
        const resp = res.data

        if(resp.response.success == '1'){              
          self.showToast(`Withdrawal Processed succefully`, {
            position: 'bottom-right',
            icon: "fa-check",
            duration: 2500,
          })
          localStorage.removeItem('UserFosas')
          setTimeout( () => self.$router.push({ name: 'dashboard' }), 2500);
          self.isLoading=false
        } else {          
          self.processingError = true
        }           
       
      })
      .catch(function (error) {
          console.log(error)
      })
    }
  },

  created(){
    this.canProcess  = (this.userData.is_registered_mobile_user == 1) ? true : false;
    console.log(this.canProcess)
    this.formdata.user = this.userData.user_id
    console.log(this.accdetails)
  }
}
</script>
  